// Swiper initialization for Blog Category Slider
document.addEventListener('DOMContentLoaded', () => {
  const swiperElement = document.querySelector('.blog-category-swiper');

  if (!swiperElement) return;

  // eslint-disable-next-line no-new, no-undef
  new Swiper('.blog-category-swiper', {
    spaceBetween: 42,
    slidesPerView: 'auto',
    slidesOffsetBefore: 20,
    slidesOffsetAfter: 20,
    breakpoints: {
      1024: {
        slidesPerView: 'auto',
        spaceBetween: 42,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
      },
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'progressbar',
    },
    grabCursor: true,
    keyboard: {
      enabled: true,
    },
    mousewheel: {
      invert: false,
      forceToAxis: true,
    },
  });
});
